import {FC, useCallback, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import FormHeader from 'components/Form/FormHeader';
import {useBackend} from 'state/backend';
import {onApiKeyError} from 'utils/request/result';
import ResultPanel from './components/ResultPanel';
import SearchPanel from './components/SearchPanel';
import {
    CustomTemplateSearchApiResult,
    SearchRequest,
    useGetCustomTemplateSearchResult,
} from './services';
import {CustomTemplateSearchBackend} from './types';

const StaffCustomTemplateSearchViewPage: FC = () => {
    const {t} = useTranslation('Staff.CustomTemplateSearch');
    const {
        data: {mid},
    } = useBackend<CustomTemplateSearchBackend>();

    const methods = useForm<{keyword: string}>();

    const {isLoading, mutateAsync} = useGetCustomTemplateSearchResult();
    const [response, setResponse] = useState<
        CustomTemplateSearchApiResult | undefined
    >();

    const onSearch = useCallback(
        (request: SearchRequest) => {
            mutateAsync({mid, ...request})
                .then((newResponse) => {
                    if (newResponse) setResponse(newResponse.data);
                })
                .catch((error) => {
                    onApiKeyError(methods, 'search')(error);
                });
        },
        [methods, mid, mutateAsync],
    );

    const onClear = useCallback(() => {
        setResponse(undefined);
    }, []);

    return (
        <div className="flex flex-col gap-y-6">
            <FormHeader subtitle={t('subtitle')} title={t('title')} />
            <FormProvider {...methods}>
                <SearchPanel
                    hide={!!response}
                    isLoading={isLoading}
                    onSearch={onSearch}
                />
                <ResultPanel
                    isLoading={isLoading}
                    onClear={onClear}
                    onSearch={onSearch}
                    response={response}
                />
            </FormProvider>
        </div>
    );
};

export default StaffCustomTemplateSearchViewPage;
